<div class="buttonContainer overflowVisible" [class.embeddedMode]="isEmbeddedMode">
  <div class="upperButtonsSection" id="upperButtons">
    @for (navBtn of upperNavButtonsInfo; track navBtn) {
      <div class="buttonPlaceHolder" id="{{navBtn.displayValue.toLowerCase()}}" [class.hidden]="isHidden(navBtn.value)"
        [class.pressed]="navBtn.value === pressedMenuName" (click)="upperNavBtnClick(navBtn.value)">
        <div class="button-wrapper2">
          <div class="button-wrapper">
            <mat-icon svgIcon={{navBtn.value}}></mat-icon>
            <div class="text">{{navBtn.displayValue}}</div>
          </div>
        </div>
      </div>
    }
    @for (button of upperButtonsInfo; track button) {
      <div class="buttonPlaceHolder" id="{{button.displayValue.toLowerCase()}}" [class.hidden]="isHidden(button.value)"
        [class.pressed]="button.value === pressedMenuName" (click)="toggleMenu(button.value)">
        <div class="button-wrapper2">
          <div class="button-wrapper">
            <mat-icon svgIcon={{button.value}}></mat-icon>
            <div class="text">{{button.displayValue}}</div>
          </div>
        </div>
      </div>
    }
  </div>
  <div class="bottomButtonsSection" id="lowerButtons">
    @for (button of lowerButtonsInfo; track button) {
      <div class="buttonPlaceHolder" [class.hidden]="isHidden(button.value)"
        [class.pressed]="button.value === pressedMenuName" (click)="toggleMenu(button.value)">
        <div class="button-wrapper2">
          <div class="button-wrapper">
            <mat-icon class="icon16" svgIcon={{button.value}}></mat-icon>
            <div class="text">{{button.displayValue}}</div>
          </div>
        </div>
      </div>
    }

    @if (userButtonInfo) {
      <div class="buttonPlaceHolder userInfo" [class.pressed]="userButtonInfo?.value === pressedMenuName"
        (click)="toggleMenu(userButtonInfo?.value)">
        <div class="button-wrapper2">
          <div class="button-wrapper icon32">
            <mat-icon class="icon32" svgIcon={{userButtonIcon}}></mat-icon>
          </div>
        </div>
      </div>
    }
  </div>
</div>
